import React, { Fragment, useEffect } from "react";
import { Col, Row } from "antd";
import DiscussionOrganizer from "./DiscussionOrganizer";
import ScrollToTop from "../../../common/cards/ScrollToTop";
import { useFetchProfileFunc } from "../../../common/hooks/useFetchProfileFunc";
import Loader from "../../../common/cards/Loader";
import useVariables from "../../../common/hooks/useVariables";

const FeedOrganizer = () => {
  const { SetInititalProfile, loading } = useFetchProfileFunc();

  const { viewer } = useVariables();
  const id = viewer?.id;

  useEffect(() => {
    if (id === null || id === undefined || !id || !viewer?.name) {
      SetInititalProfile("organizer");
      console.log("called");
      console.log(loading);
    }
  }, [id]);
  return (
    <Fragment>
      {loading || !id || id === null || id === undefined ? (
        <Loader fullpage loading="white" />
      ) : null}
      <ScrollToTop />
      <Row justify="center" className="rowPaddingHome">
        <Col
          xs={{ span: 24, order: 3 }}
          sm={{ span: 24, order: 3 }}
          md={{ span: 24, order: 3 }}
          lg={{ span: 15, order: 2 }}>
          <DiscussionOrganizer />
        </Col>
      </Row>
    </Fragment>
  );
};

export default FeedOrganizer;
